import { Box, HStack, IconButton, Stack, Text } from '@genial/components';
import { BoxRadius, Color } from '@genial/design-tokens';
import { useBreakpointValue } from '@genial/utils';
import React from 'react';

import { CustomerDuckCopyIcon } from '../../Account/components/InfoContainer/components/CustomerDuckCopyIcon';

import { InfoPanelTypes } from '.';

export const InfoPanelProfile: React.FC<InfoPanelTypes.PanelProfileProps> = ({
  isLoading,
  customer,
  profileNavigate,
}) => {
  const isMobile = useBreakpointValue({ base: true, sm: false } as const);
  const stackDirection = useBreakpointValue({ base: 'row', sm: 'column' } as const);
  const textAlign = useBreakpointValue({ base: 'right', sm: 'left' } as const);
  const stackContentDirection = useBreakpointValue({ base: 'column', sm: 'row' } as const);
  const textVariant = useBreakpointValue({ base: undefined, sm: 'bold' } as const);

  return (
    <Stack
      direction={stackContentDirection}
      space="stack.nano"
      width="full"
      backgroundColor={Color.background}
      p="inline.xxxs"
      borderRadius={BoxRadius.sm}>
      <Box
        width={isMobile ? 'full' : '20%'}
        alignItems={isMobile ? 'flex-start' : undefined}
        justifyContent={isMobile ? 'flex-start' : 'center'}>
        <Text
          fontSize="lg"
          fontWeight="semibold"
          color={isMobile ? 'neutral.black' : 'neutral.dark'}>
          Dados Pessoais
        </Text>
      </Box>
      <Stack
        flex={1}
        direction={stackContentDirection}
        space={isMobile ? 'stack.nano' : 'stack.quarck'}>
        <Stack direction={stackDirection} space="stack.quarck" flex={1}>
          <Text fontSize="md" variant={textVariant}>
            CPF/CNPJ
          </Text>
          <Text isLoading={isLoading} fontSize="md" textAlign={textAlign} flex={1}>
            {customer?.personalInformation.cpfCnpjNormalized}
          </Text>
        </Stack>
        <Stack direction={stackDirection} space="stack.quarck" flex={1}>
          <Text fontSize="md" variant={textVariant}>
            Telefone
          </Text>
          <HStack
            space="inline.quarck"
            alignItems={isMobile ? 'flex-end' : 'flex-start'}
            justifyContent={isMobile ? 'flex-end' : 'inherit'}
            flex={1}>
            <Text
              isLoading={isLoading}
              fontSize="md"
              textAlign={textAlign}
              flex={isLoading ? 1 : undefined}>
              {customer?.personalInformation.phoneNumberNormalized}
            </Text>
            {!!customer?.personalInformation.phoneNumberNormalized && (
              <CustomerDuckCopyIcon
                valueToCopy={customer?.personalInformation.phoneNumberNormalized}
              />
            )}
          </HStack>
        </Stack>
        <Stack direction={stackDirection} space="stack.quarck" flex={1}>
          <Text fontSize="md" variant={textVariant}>
            Data de nascimento
          </Text>
          <Text isLoading={isLoading} fontSize="md" textAlign={textAlign} flex={1}>
            {customer?.personalInformation.birthDateNormalized}
          </Text>
        </Stack>
        <Stack direction={stackDirection} space="stack.quarck" flex={1}>
          <Text fontSize="md" variant={textVariant}>
            Cidade
          </Text>
          <Text isLoading={isLoading} fontSize="md" textAlign={textAlign} flex={1}>
            {customer?.residentialData.cityWithStateNormalized}
          </Text>
        </Stack>
        {!isMobile && (
          <IconButton
            onPress={profileNavigate}
            icon="ChevronRight"
            testId="goto-personal-data"
            iconColor="brand.primary.principal"
            iconSize="xs"
          />
        )}
      </Stack>
    </Stack>
  );
};
